module.exports = __webpack_public_path__ + "static/media/confirmed.55bdf69c.svg";